import * as React from 'react';
import styled from 'styled-components/native';

import { ThrobberBehavior } from 'components/Routes/utils/isFetchingWithThrobberPredicateFactory/checkThrobberBehavior';
import { RoleProps, roles } from 'cross-platform/utils/roleProps';
import { COPYRIGHT_TEXT } from 'lib/strings';

import { CollapsedNavText } from './components/Text';
import { useProductStreamVersion } from './hooks/useProductStreamVersion';

const DOMAIN = 'NavFooter';

const Wrapper = styled.View<WrapperProps>`
  width: 100%;
  height: 44px;
  margin-top: auto;
  padding-left: 40px;
  padding-right: 40px;
  margin-bottom: 40px;
  flex-direction: column;
  justify-content: space-between;
`;
Wrapper.displayName = `${DOMAIN}.Wrapper`;

type FooterProps = React.ComponentProps<typeof Wrapper> & RoleProps;
type WrapperProps = { color: string };

export const NavFooter = (props: FooterProps): React.ReactElement => {
  const productStreamVersion = useProductStreamVersion({
    meta: { throbberBehavior: ThrobberBehavior.ALWAYS_HIDDEN },
  });
  return (
    <Wrapper {...props} {...roles.pass(props, DOMAIN)}>
      <CollapsedNavText text={COPYRIGHT_TEXT} />
      <CollapsedNavText text={productStreamVersion} />
    </Wrapper>
  );
};
